import Penpal from 'penpal'

export const updateBrowserUrl = (targetUrl = null) => {
  if (!window.history.pushState) return

  let href, params
  const { origin, pathname, search } = new URL(window.location.href)

  if (typeof (targetUrl) === 'string') {
    const parsedUrl = new URL(targetUrl)
    // if link_to URL contains pre-defined params then merge it with existing param
    if (parsedUrl.search) {
      params = { ...$.deparam(search.substr(1)), ...$.deparam(parsedUrl.search.substr(1)) }
      params = $.param(params)
    }
    href = parsedUrl.origin + parsedUrl.pathname
  } else {
    href = origin + pathname
  }

  const searchParams = targetUrl?.detail?.searchParams
  if (!params && searchParams) {
    let formattedParams = searchParams
    if (typeof (formattedParams) === 'object') {
      formattedParams = $.param(formattedParams)
    }
    params = formattedParams
  }

  const newURL = params ? `${href}?${params}` : href

  if (targetUrl !== newURL) {
    window.history.pushState({ path: newURL }, '', newURL)
  }
  // notify URL change to ember
  notifyUrlChange(newURL)
}

// updates the URL on ember side
export const notifyUrlChange = (targetUrl) => {
  const connection = connectToParent()
  if (connection) {
    connection.promise.then((parent) => {
      // TODO: Remove extra args from Ember updateUrl
      parent.updateUrl(targetUrl, null, null, null)
    })
  }
}

export const connectToParent = () => {
  let connection = null
  try {
    const opts = {
      methods: {
        dispatchEventOnWindow(msg, opts = {}) {
          const evt = new CustomEvent(msg, opts)
          window.dispatchEvent(evt)
        }
      }
    }
    connection = Penpal.connectToParent(opts)
  } catch (e) {
    if (e.code === 'NotInIframe') {
      console.warn('Not loaded in iFrame.', e)
    } else {
      console.warn('Error with parent iFrame connection.', e)
    }
  }
  return connection
}
